import api from '../../api/offers'

export default {
  state: {
    massCampaignsCreationResult: [],
  },
  namespaced: true,
  mutations: {},
  actions: {
    async createMassCampaignsStore({commit, dispatch}, data) {
        return await api.createMassCampaigns(data)
    }
  },
  getters: {},

}
